// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { useNavigateBack } from '@iheartjane/menu';
import { Button, AlertIcon, Flex, Typography } from '@iheartjane/reefer';
import { useCallback } from 'react';
import { useLocation } from 'react-router';

import { useStoreId } from '@jane/business-admin/hooks/useStoreId';
import { EventNames, track } from '@jane/business-admin/util';

const TitleText = styled(Typography)({
  fontSize: '32px',
});

export const UnauthorizedAccess = ({
  resourceName,
  variant = 'edit',
}: {
  resourceName: string;
  variant?: 'edit' | 'view';
}) => {
  const { pathname } = useLocation();
  const storeId = useStoreId();
  const goBack = useNavigateBack();

  const trackAndRedirect = useCallback(() => {
    track({
      event: EventNames.AccessDenied,
      reason: 'Missing permission',
    });

    goBack();
  }, [pathname, storeId]);

  return (
    <Flex width="432px" mx="auto" justifyContent="center">
      <Flex
        my={128}
        mx={40}
        justifyContent="flex-start"
        alignItems="center"
        flexDirection="column"
        width="432px"
      >
        <AlertIcon size="xxl" mb={24} />
        <Flex flexDirection="column" width="432px">
          <TitleText mb={8} variant="h1-semibold" textAlign="center">
            Unauthorized Access
          </TitleText>
          <Typography mb={24} color="grays-dark" textAlign="center">
            You do not have permission to {variant} {resourceName}. Contact your
            account administrator for access.
          </Typography>
          <Button
            full
            variant="primary"
            onClick={trackAndRedirect}
            label="Go back"
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
